var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/* eslint-disable no-restricted-imports */
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctAddressList, FctDecimals, FctTimestamp, FctValue } from '../../../../Fct/generics';
import { getAllCurrencies } from '../../../../Fct/plugins/allowanceRequiredProtocols';
import { amountOutMinRisk } from '../../uniswap/actions/params';
import { ROUTER_ADDRESSES } from '../constants';
import { getToken } from '../helpers/getToken';
import { SwapExactETHForTokens } from './ETH/SwapExactETHForTokens';
import { SwapExactTokensForETH } from './ETH/SwapExactTokensForETH';
import { SwapExactTokensForTokens } from './SwapExactTokensForTokens';
export var SimpleSwap = createPlugin({
    protocol: 'SUSHISWAP',
    type: 'ACTION',
    method: 'simpleSwap',
    name: 'swap',
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({ destination: 'uniswap_router' }),
                methodParams: {
                    addressIn: new FctAddress({ options: getAllCurrencies({ chainId: chainId }), destination: 'erc20' }),
                    amountIn: new FctValue({ destination: 'wei_amount' }),
                    decimalsIn: new FctDecimals({ destination: 'wei_amount' }),
                    addressOut: new FctAddress({ options: getAllCurrencies({ chainId: chainId }), destination: 'erc20' }),
                    amountOut: new FctValue({ destination: 'wei_amount', risk: amountOutMinRisk }),
                    decimalsOut: new FctDecimals({ destination: 'wei_amount' }),
                    path: new FctAddressList({ destination: 'ERC20_List', options: getAllCurrencies({ chainId: chainId }) }),
                    to: new FctAddress({}),
                    deadline: new FctTimestamp({}),
                },
            },
            output: {
                amountIn: new FctValue({ destination: 'wei_amount', innerIndex: 2 }),
                amountOut: new FctValue({ destination: 'wei_amount', innerIndex: -1 }),
            },
        });
    },
    getParamsOnCreate: function (_a) {
        var chainId = _a.chainId, params = _a.params;
        return __awaiter(void 0, void 0, void 0, function () {
            var _b, to, deadline, path, _c, addressIn, amountIn, decimalsIn, _d, addressOut, decimalsOut, amountOut, requiredParams, requiredParams_1, requiredParams_1_1, param, inputToken, outputToken, plugin_1, plugin_2, plugin;
            var e_1, _e;
            return __generator(this, function (_f) {
                _b = params.methodParams, to = _b.to, deadline = _b.deadline;
                path = params.methodParams.path;
                _c = params.methodParams, addressIn = _c.addressIn, amountIn = _c.amountIn, decimalsIn = _c.decimalsIn;
                _d = params.methodParams, addressOut = _d.addressOut, decimalsOut = _d.decimalsOut, amountOut = _d.amountOut;
                requiredParams = [
                    { value: addressIn.value, key: 'addressIn' },
                    { value: decimalsIn.value, key: 'decimalsIn' },
                    { value: amountOut.value, key: 'amountOut' },
                    { value: decimalsOut.value, key: 'decimalsOut' },
                    { value: to.value, key: 'to' },
                ];
                try {
                    for (requiredParams_1 = __values(requiredParams), requiredParams_1_1 = requiredParams_1.next(); !requiredParams_1_1.done; requiredParams_1_1 = requiredParams_1.next()) {
                        param = requiredParams_1_1.value;
                        if (!param.value) {
                            console.error("wrong param ".concat(param.key, ": ").concat(param.value));
                            return [2 /*return*/];
                        }
                        if (typeof param.value !== 'string') {
                            console.error("wrong param ".concat(param.key, ": should be a string"));
                            return [2 /*return*/];
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (requiredParams_1_1 && !requiredParams_1_1.done && (_e = requiredParams_1.return)) _e.call(requiredParams_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                if (!path.value) {
                    console.error("wrong param path: ".concat(path.value));
                    return [2 /*return*/];
                }
                if (!Array.isArray(path.value) || typeof path.value[0] !== 'string') {
                    console.error("wrong param path: should be an array of strings");
                    return [2 /*return*/];
                }
                if (!amountIn.value) {
                    console.error("wrong param amountIn: ".concat(amountIn.value));
                    return [2 /*return*/];
                }
                inputToken = getToken({ address: addressIn.value, decimals: Number(decimalsIn.value) }, Number(chainId));
                outputToken = getToken({ address: addressOut.value, decimals: Number(decimalsOut.value) }, Number(chainId));
                if (inputToken.isNative) {
                    plugin_1 = new SwapExactETHForTokens({
                        chainId: chainId,
                        initParams: {
                            to: params.to.value,
                            value: amountIn.value,
                            methodParams: {
                                amountOutMin: amountOut.value,
                                path: path.value,
                                to: to.value,
                                deadline: deadline.value,
                            },
                        },
                    });
                    return [2 /*return*/, { params: plugin_1.input.params, method: plugin_1.method, gasLimit: plugin_1.gasLimit }];
                }
                if (outputToken.isNative) {
                    plugin_2 = new SwapExactTokensForETH({
                        chainId: chainId,
                        initParams: {
                            to: params.to.value,
                            methodParams: {
                                amountIn: amountIn.value,
                                amountOutMin: amountOut.value,
                                path: path.value,
                                to: to.value,
                                deadline: deadline.value,
                            },
                        },
                    });
                    return [2 /*return*/, { params: plugin_2.input.params, method: plugin_2.method, gasLimit: plugin_2.gasLimit }];
                }
                plugin = new SwapExactTokensForTokens({
                    chainId: chainId,
                    initParams: {
                        to: params.to.value,
                        methodParams: {
                            amountIn: amountIn.value,
                            amountOutMin: amountOut.value,
                            path: path.value,
                            to: to.value,
                            deadline: deadline.value,
                        },
                    },
                });
                return [2 /*return*/, { params: plugin.input.params, method: plugin.method, gasLimit: plugin.gasLimit }];
            });
        });
    },
    supportedContracts: ROUTER_ADDRESSES,
    initParams: {
        methodParams: {
            deadline: { type: 'global', id: 'blockTimestamp' },
        },
    },
});
